import { ref, computed, Ref } from "vue";
import { LotListItem } from "./useLotsData";
import { LotStatus } from "@/enums/LotStatus";

export function useLotsSelection(lotList: Ref<LotListItem[]>) {
  const isSelectAll = ref(false);

  const selectedLotsList = computed(() => {
    return lotList.value.filter((item) => item.selected);
  });

  const selectedForReleaseList = computed(() => {
    return lotList.value.filter(
      (item) => item.selected && item.status === LotStatus.NOT_RELEASED
    );
  });

  const selectedForOptionList = computed(() => {
    return lotList.value.filter(
      (item) =>
        item.selected &&
        (item.status === LotStatus.NOT_RELEASED ||
          item.status === LotStatus.AVAILABLE)
    );
  });

  const showRelease = computed(() => {
    if (selectedLotsList.value.length === 0) return false;

    return selectedForReleaseList.value.length > 0;
  });

  const showCreateOption = computed(() => {
    if (selectedLotsList.value.length === 0) return false;

    return selectedForOptionList.value.length > 0;
  });

  const selectLot = (isSelected: boolean, index: number) => {
    lotList.value[index].selected = isSelected;
    isSelectAll.value = selectedLotsList.value.length > 0;
  };

  const selectAll = (isSelect: boolean) => {
    isSelectAll.value = isSelect;
    lotList.value.forEach((item) => {
      item.selected = isSelect;
    });
  };

  const clearSelection = () => {
    isSelectAll.value = false;
    lotList.value.forEach((item) => {
      item.selected = false;
    });
  };

  return {
    isSelectAll,
    selectedLotsList,
    selectedForReleaseList,
    selectedForOptionList,
    showRelease,
    showCreateOption,
    selectLot,
    selectAll,
    clearSelection,
  };
}
